import { useEffect, useState } from 'react';
import { Package, ZoomIn } from 'lucide-react';
import { publicImageUrl } from '../../lib/media';
import { Dialog, DialogTrigger } from '../../components/ui/dialog';
import { ProductPhotoViewer } from './ProductPhotoViewer';

export const OTCProductPhoto = ({ product }) => {
  const [failed, setFailed] = useState(false);
  const [open, setOpen] = useState(false);
  const photos = product.photos?.length ? product.photos : (product.image_url ? [product.image_url] : []);
  const cover = photos[0] || '';
  useEffect(() => { setFailed(false); setOpen(false); }, [cover]);
  return <Dialog open={open} onOpenChange={setOpen}><div className="otc-product-image" data-testid={`otc-photo-${product.product_id}`}>
    {cover && !failed ? <DialogTrigger asChild><button type="button" className="otc-product-image-button"
      data-testid={`otc-photo-zoom-${product.product_id}`} aria-label={`View photos and details for ${product.name}`} title="View product details">
      <img src={publicImageUrl(cover)} alt={product.name} loading="lazy"
        onError={() => { setFailed(true); setOpen(false); }} data-testid={`otc-photo-image-${product.product_id}`} />
      <span className="otc-photo-zoom-hint" aria-hidden="true"><ZoomIn size={17} /></span>
    </button></DialogTrigger>
      : <Package size={40} className="text-slate-300" aria-label="No product photo" data-testid={`otc-photo-placeholder-${product.product_id}`} />}
  </div>{open && <ProductPhotoViewer name={product.name} description={product.description} photos={photos} />}</Dialog>;
};